import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonDataService } from '../shared/services/common-data.service';

@Injectable({
  providedIn: 'root'
})
export class NfoAccessGuard implements CanActivate {
  constructor(
    private commonDataService: CommonDataService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.commonDataService.isNFOActive().pipe(
      map((isAccessible) => {
        if (!isAccessible) {
          this.router.navigate(['/page-not-found']);
          return false;
        }
        return true;
      })
    );
  }
}
